module.exports = __webpack_public_path__ + "static/media/logo-super-auto.059d3ed6.svg";